import {PropertyBase} from "./PropertyBase";
import * as React from "react";
import {SlateEditor} from "shared/controls/SingleInputs/SlateEditor/SlateEditor";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {library} from "@fortawesome/fontawesome-svg-core";

import { css, cx } from 'emotion'
import {ToastService} from "shared/utilities/services/ToastService";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {faArrowsAlt} from "@fortawesome/free-solid-svg-icons/faArrowsAlt";
import {PDFControlBase} from "../Core/PDFControlBase";
import {FieldPicker} from "PageBuilder/Dialogs/FieldPicker";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {FieldsPropertyItemSettings} from "InternalShared/PageBuilder/Controls/Properties/FieldPropertyItemSettings/FieldsPropertyItemSettings";
import {FieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";

let Sortable=require('sortablejs');

declare let rednaoPDFInvoiceParams:any;


library.add(faTrash);
library.add(faArrowsAlt);

export class FieldsProperty extends PropertyBase{
    public label:string='Text';
    private elementID:string;
    private tBody:any;

    constructor(public toolItem:PDFControlBase, public OptionsPropertyName:string, OptionsOverWrite:any=null)
    {
        super(toolItem,OptionsPropertyName,OptionsOverWrite);

    }


    ComponentDidMount() {
        new Sortable(this.tBody,{animation:150,onUpdate:e=>{this.Rearange(e.from)},handle:'.handle'});
    }

    public SubRenderer(): React.ReactNode {
        let fields:{Id:string,Label:string,FieldSettings:FieldControlOptions}[]=this.GetOptionValue();
        let allFields=this.toolItem.Page.Form.Fields;
        return(
            <div>
                <label>{this.label}</label>
                <table style={{margin:5,width:'100%'}}>
                    <thead>
                        <tr>
                            <td>
                                <div style={{width:'calc(100% - 90px)',display:'inline-block',fontWeight:'bold',marginBottom:10}}>
                                    Name
                                </div>
                                <div style={{width:90,display:'inline-block',fontWeight:'bold',textAlign:'center',marginBottom:10}}>
                                    Actions
                                </div>
                            </td>
                        </tr>
                    </thead>
                    <tbody ref={node=>{this.tBody=node}}>
                        {fields.map(x=>
                            <tr key={x.Id} data-id={x.Id}>
                                <td>
                                   <FieldsPropertyItemSettings Field={x} OnDelete={()=>this.Delete(x)}/>
                                </td>
                            </tr>

                        )}
                    </tbody>
                </table>
                <a href={'#'} onClick={e=>this.AddField()}>Add Field</a>
            </div>
        )
    }


    private Delete(deletedItem: { Id: string; Label: string,FieldSettings:FieldControlOptions }) {
        let fields:{Id:string,Label:string}[]=this.GetOptionValue();

        if(fields.length==1) {
            ToastService.SendErrorMessage('You should have at least one field');
            return;
        }

        let fieldToDelete=fields.find(x=>x.Id==deletedItem.Id);

        if(fieldToDelete!=null)
            fields.splice(fields.indexOf(fieldToDelete),1);

        this.SetOptionValue(fields);
    }

    private  async AddField() {
        let field:{Id:string,Label:string}=await Dialog.Show(<FieldPicker AlreadySelectedFields={this.GetOptionValue()} Page={this.toolItem.Page} />);
        if(field!=null)
        {
            let fieldList:{Id:string,Label:string,FieldSettings:FieldControlOptions}[]=this.GetOptionValue();
            fieldList.push({Id:field.Id,Label:field.Label,FieldSettings:new FieldControlOptions().Merge()});
            this.SetOptionValue(fieldList);

        }
    }

    private Rearange(from: HTMLElement) {
        let rows:HTMLElement[]=from.querySelectorAll('tr') as any;
        let newFieldOrder=[];
        let fieldList:{Id:string,Label:string}[]=this.GetOptionValue();
        for(let row of rows)
        {
            let id=row.getAttribute('data-id');

            newFieldOrder.push(fieldList.find(x=>x.Id==id));
        }

        this.SetOptionValue(newFieldOrder);
    }
}

